<template>
    <div class="codics-aonaer-info-sys-video-body">
        <WebHeader></WebHeader>
        <BreadCrumb :bread-list="breadList" style="margin-top:100px;">
            <el-cascader class="codics-aonaer-info-sys-video-pick"
                style="float: right;top: 50%;transform: translateY(-50%);" v-model="nowType" placeholder="请选择视频分类"
                filterable :options="typeData"
                :props="{ checkStrictly: true, value: 'id', label: 'value', children: 'data' }" clearable
                @change="listVideoFuc"></el-cascader>
        </BreadCrumb>
        <div class="codics-aonaer-info-sys-video-box">
            <div class="codics-aonaer-info-sys-video-container">
                <div class="codics-aonaer-info-sys-video-item" v-for="(item, index) in videoList" :key="index"
                    @click="playVideo('https://cdn.bosscaigou.com/' + item.url);">
                    <div class="codics-aonaer-info-sys-video-item-card" :data-title="item.title">
                        <el-image class="codics-aonaer-info-sys-video-item-himg"
                            :src="'https://cdn.bosscaigou.com/' + item.himg" fit="cover"></el-image>
                        <div class="iconfont codics-aonaer-info-sys-video-item-icon">&#xe7c1;</div>
                    </div>
                </div>
            </div>
        </div>
        <el-pagination class="codics-aonaer-info-sys-news-pagination" background @size-change="handleSizeChange"
            @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[12, 24, 36, 48]"
            :page-size="pgeSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
        <WebFooter></WebFooter>
        <VideoDialog v-model="dialogVisible" ref="videoPlayer" :url="videoUrl"></VideoDialog>
    </div>
</template>

<script>
import VideoDialog from '@/components/VideoDialog';
import WebHeader from '@/components/WebHeader';
import WebFooter from '@/components/WebFooter';
import BreadCrumb from '@/components/BreadCrumb';
import { listMp4, listMp4Type } from '@/api';
export default {
    data() {
        return {
            nowType: 2,
            typeData: [],
            dialogVisible: false,
            breadList: [
                {
                    title: '网站首页',
                    url: '#'
                },
                {
                    title: '奥纳尔',
                    url: '#'
                },
                {
                    title: '公司视频',
                    url: '#'
                }
            ],
            videoUrl: '',
            pgeSize: 12,
            pageNum: 1,
            total: 0,
            videoList: []
        }
    },
    mounted() {
        this.listVideoFuc();
        this.listMp4TypeFuc();
    },
    methods: {
        async listMp4TypeFuc() {

            const loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listMp4Type();

            loading.close();

            if (data.code == 200) {

                this.typeData = data.data;

                this.initChildren(this.typeData);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        initChildren(list) {

            for (var i = 0; i < list.length; i++) {

                if (list[i]?.data != null) {

                    // list[i].hasChildren = true;

                    this.initChildren(list[i].data);

                } else {

                    // delete list[i].children;

                }

            }

        },
        playVideo(url) {
            this.dialogVisible = true;
            this.$refs.videoPlayer.playVideo(url);
        },
        async listVideoFuc() {
            let data = await listMp4({
                type: this.nowType,
                pge: this.pageNum,
                psz: this.pgeSize
            })
            if (data.code == 200) {
                this.videoList = data.data;
                this.total = data.count;
            } else {
                this.$message.error(data.message);
            }
        },
        handleSizeChange(val) {
            this.pgeSize = val;
            this.listVideoFuc();
        },

        handleCurrentChange(val) {
            this.pageNum = val;
            this.listVideoFuc();
        },
    },
    components: {
        WebHeader,
        WebFooter,
        BreadCrumb,
        VideoDialog
    }
}
</script>

<style>
.codics-aonaer-info-sys-video-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
}

.codics-aonaer-info-sys-video-box {
    height: fit-content;
    min-height: calc(100vh - 354px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 40px 0;
}

.codics-aonaer-info-sys-video-container {
    height: 100%;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    box-sizing: border-box;
    padding: 0 5px;
}

.codics-aonaer-info-sys-video-item {
    height: 300px;
    width: 33.33333333%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 15px;
}

.codics-aonaer-info-sys-video-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    background: #EEE;
    border-radius: 2px;
    overflow: hidden;
    box-sizing: border-box;
    padding-bottom: 56px;
    cursor: pointer;
}

.codics-aonaer-info-sys-video-item-card:hover:after {
    color: chocolate;
}

.codics-aonaer-info-sys-video-item-card:hover:before {
    opacity: 1;
}

.codics-aonaer-info-sys-video-item-himg {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-video-item-card::before {
    content: '';
    height: calc(100% - 56px);
    width: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, .55);
    transition: all .3s;
    z-index: 1;
    opacity: 0;
}

.codics-aonaer-info-sys-video-item-card::after {
    content: attr(data-title);
    height: 56px;
    width: 100%;
    position: absolute;
    margin: auto;
    bottom: 0;
    left: 0;
    line-height: 56px;
    text-align: center;
    font-size: 14px;
    color: #000;
    transition: all .3s;
}

.codics-aonaer-info-sys-video-item-icon {
    height: 52px;
    width: 52px;
    position: absolute;
    margin: auto;
    top: -56px;
    left: 0;
    right: 0;
    bottom: 0;
    color: #333;
    font-size: 26px;
    line-height: 54px;
    text-align: center;
    box-sizing: border-box;
    background: rgba(255, 255, 255, .6);
    border-radius: 26px;
    z-index: 2;
}
</style>